import { formatValue, NumeralTypes } from '../numeral.component';

export const percentageFormatter = value => formatValue({
  type: NumeralTypes.PERCENTAGE,
  value,
});
